import { MessageContentBlock } from "@hex/common";

import {
  DEFAULT_PROJECT_TITLE,
  DEFAULT_THREAD_TITLE,
} from "../../../logic/shared";

import { useGetRecentThreadsQuery } from "./queries.generated";

export const getThreadTitle = (
  hexTitle: string | null,
  threadTitle: string | null,
  latestUserMessageContent: ReadonlyArray<MessageContentBlock | null>,
): string | null => {
  const useHexTitle =
    hexTitle &&
    (hexTitle !== DEFAULT_PROJECT_TITLE ||
      threadTitle !== DEFAULT_THREAD_TITLE);
  // Prioritize an ai generated title over the most recent user prompt.
  // If you don't load a recent user prompt, then use the thread title, which was the first prompt.
  const latestUserMessageText =
    latestUserMessageContent &&
    latestUserMessageContent.length > 0 &&
    latestUserMessageContent[0]?.type === "text"
      ? latestUserMessageContent[0].text
      : null;
  return useHexTitle ? hexTitle : (latestUserMessageText ?? threadTitle);
};

export type RecentThreadItemType = ReturnType<
  typeof useRecentThreads
>["threads"][number];

/**
 * Hook to fetch recent ASK threads for the Jump back in section
 */
export const useRecentThreads = (limit = 10, skip = false) => {
  const { data, error, loading } = useGetRecentThreadsQuery({
    variables: {
      first: limit,
      threadType: "ASK",
    },
    fetchPolicy: "cache-and-network",
    skip,
  });

  const threads =
    data?.agentChatThreadsConnection?.edges
      ?.filter((edge) => edge.node.hex?.trashDate == null)
      .map((edge) => ({
        id: edge.node.id,
        hexId: edge.node.hex?.id,
        title:
          getThreadTitle(
            edge.node.hex?.title ?? null,
            edge.node.title,
            edge.node.latestUserMessage?.content ?? [],
          ) ?? edge.node.title,
        createdDate: edge.node.createdDate,
        revision: edge.node.revision,
        msgCount: edge.node.messageCount,
        lastUpdated: edge.node.latestUserMessage?.createdDate,
        threadOwnerUserId: edge.node.user.id,
        threadOwnerUserEmail: edge.node.user.email,
        threadOwnerUserName: edge.node.user.name,
      })) || [];

  return {
    threads,
    loading,
    error,
  };
};
